export const privacyPolicy = `
# DORIDIUM PRIVACY POLICY 

*Last updated: Aug 31st 2025*

Welcome to Doridium (“we,” “us,” or “our”). We are based in Seattle, Washington, USA. We sell and ship original fine art directly to customers. We are committed to protecting your privacy. This Privacy Policy describes how we collect, use, and protect your information. Please read it carefully.  

This Privacy Policy forms part of our [Terms of Service](terms-of-service). If there is any conflict, this Privacy Policy will govern with respect to data and privacy matters.

# 1. When We Collect Your Infromation and Consent

By accessing our site, you accept our [Privacy Policy](privacy-policy) and [Terms of Service](terms-of-service), and you consent to our collection, storage, use and disclosure of your information as described in this Privacy Policy.

# 2. Information We Collect

We collect the following Personal information when you place an order:

 - Name

 - Email address

 - Shipping address

Payment information is processed directly by our payment providers (Stripe, PayPal) under their own terms and privacy policies, which govern your use of their services

We may collect the following Non-Personal information provided to us by your browser when you access our website:

 - The website you came from (known as the “referring URL”)

 - The type of browser you use

 - The device from which you connected

 - The time and date of access

 - Other information that does not personally identify you.



# 3. How We Use Your Information

We use your Personal information only to:

 - Process and ship your order

 - Contact you regarding your order

 - Respond to customer service inquiries

 - Report taxes

We do not use your information for marketing unless you have indicated you wish to opt in.

You can withdraw consent for marketing at any time by contacting support via email at [contact@doridium.com](mailto:contact@doridium.com).

We use you Non-Personal information only to:

 - Maintain the quality of our site

 - Provide general statistics regarding use of our site

 - Other business purposes

# 4. Legal Basis for Processing (GDPR – if applicable)

If you reside in the European Economic Area (EEA), we process your data on these legal bases:

 - To fulfill a contract (your purchase)

 - To comply with legal obligations

 - With your consent (for optional marketing)

# 5. Your Rights (GDPR / CCPA)

Depending on your jurisdiction, you may have the right to:

 - Access your personal data

 - Correct inaccuracies

 - Request deletion

 - Object to processing

 - Request data portability

 - Withdraw consent (if given)

To exercise your rights, email: [contact@doridium.com](mailto:contact@doridium.com). We will respond within 30 days.

# 6. Data Retention

We retain your name, email, shipping address, and purchase history for up to 7 years for legal, accounting, and tax compliance purposes. After that, your data is securely deleted or anonymized unless needed for dispute resolution or legal obligations.

# 7. Sharing of Information

We only share your data with:

 - Payment processors (e.g., Stripe, PayPal)

 - Shipping providers

 - Legal authorities, if required by law

We do not sell or rent your Personal or Non-Personal information to third parties.

Certain third-party service providers, such as payment processors, have their own privacy policies in respect of the information that we are required to provide to them in order to use their services.  For these third-party service providers, we recommend that you read their privacy policies so that you can understand the manner in which your Personal Information will be handled by such providers.

# 8. International Transfers

If you access our site from outside the United States, you consent to your data being transferred to and stored in the U.S., where privacy laws may be different from your local laws.

# 9. Cookies

Our website may use cookies to enhance user experience and functionality. You may disable cookies in your browser settings.

# 10. Children’s Privacy

Our website is not intended for children under 13. We do not knowingly collect information from minors. If you believe a child has provided us data, please contact us for deletion.

# 11. Changes to This Policy

We may update this Privacy Policy from time to time. Changes will be posted here with a new "Last updated" date. Continued use of the site constitutes your acceptance of the updated policy.

# 12. Language

This Privacy Policy is provided in English. Any translations are for informational purposes only. If any translated version conflicts with the English version, the English version shall take precedence.

Contact:

Doridium  
2226 Eastlake Ave E Unit #789  
Seattle, WA 98102

[contact@doridium.com](mailto:contact@doridium.com)  
`;